module.exports = __webpack_public_path__ + "img/logo-desktop.8467c789.png";